import { Body } from "@sprout/typography.tsx";
import { SecondaryButton } from "@sprout/buttons";
import ErrorIcon from "@sprout/icons/error.tsx";
import useTranslation from "@hooks/use_translation.ts";
import { Link } from "@inertiajs/react";

type Props = {
  emailPreferencesPath?: string;
};

export const PausedBanner = ({ emailPreferencesPath }: Props) => {
  const { t } = useTranslation("jobAlerts");

  return (
    <div className="flex items-center justify-between gap-4 px-5 py-4 rounded-lg bg-[var(--yellow-e25)]">
      <div className="flex items-start gap-3">
        <div className="shrink-0 pt-[2px]">
          <ErrorIcon color="yellow" size="md" />
        </div>
        <div className="flex flex-col gap-[2px]">
          <Body medium>{t("paused.title")}</Body>
          <Body>{t("paused.body")}</Body>
        </div>
      </div>
      {emailPreferencesPath && (
        <Link href={emailPreferencesPath}>
          <SecondaryButton>{t("paused.notificationSettings")}</SecondaryButton>
        </Link>
      )}
    </div>
  );
};
